var render, staticRenderFns
import script from "./ThgClosingWithHint.vue?vue&type=script&lang=ts"
export * from "./ThgClosingWithHint.vue?vue&type=script&lang=ts"
import style0 from "./ThgClosingWithHint.vue?vue&type=style&index=0&id=704363b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704363b8",
  null
  
)

export default component.exports